import * as React from 'react';
import { useDrawerDirection, Drawer } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { useIntl, useSelector, statusSuccess } from '@grandvisionhq/state';
import '../../../../state/actions.js';
import '../../../../state/add-to-cart/selectors.js';
import '../../../../state/bundles/selectors.js';
import '../../../../state/bundles/reducer.js';
import { getPrescription } from '../../../../state/configurator/selectors.js';
import '../../../../state/configurator/reducer.js';
import '../../../../state/products/selectors.js';
import '../../../../state/products/reducer.js';
import { PrescriptionFormLabelDetailsCTA } from './PrescriptionFormLabelDetailsCTA.js';

const PrescriptionFormLabelDetails = ()=>{
    const { getLabel  } = useIntl();
    const title = getLabel('products.configurator.step.prescription.opticalparams.details');
    const prescription = useSelector(getPrescription);
    if (!statusSuccess(prescription)) {
        // Loading / error states are handled further up the tree
        return null;
    }
    const opticalParameters = prescription.result.parameters;
    return /*#__PURE__*/ React.createElement(PrescriptionFormLabelDetailsDrawer, {
        ctaButton: /*#__PURE__*/ React.createElement(PrescriptionFormLabelDetailsCTA, {
            title: title
        }),
        title: title,
        "data-t": "prescription-form-drawer"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "prescription-form-label-details"
    }, /*#__PURE__*/ React.createElement("dl", {
        "aria-label": title,
        className: "prescription-form-label-details__list"
    }, opticalParameters.map((item, index)=>{
        return /*#__PURE__*/ React.createElement("div", {
            className: 'prescription-form-label-details__item',
            key: index
        }, /*#__PURE__*/ React.createElement("dt", null, /*#__PURE__*/ React.createElement(Heading, {
            component: "h4",
            variant: "subheading1",
            className: "prescription-form-label-details__item--label"
        }, getLabel(`products.glasses.prescription.${item.name}`))), /*#__PURE__*/ React.createElement("dd", {
            className: "prescription-form-label-details__item--text"
        }, getLabel(`products.glasses.prescription.${item.name}.tooltip`)));
    }))));
};
const PrescriptionFormLabelDetailsDrawer = ({ title , ctaButton , children , 'data-t': dataT ,  })=>{
    const drawerDirection = useDrawerDirection();
    const isRightDirection = drawerDirection === 'right';
    const Title = isRightDirection ? undefined : ({ className  })=>/*#__PURE__*/ React.createElement(Drawer.Title, {
            className: className
        }, title)
    ;
    return /*#__PURE__*/ React.createElement(Drawer, {
        direction: drawerDirection
    }, ctaButton, /*#__PURE__*/ React.createElement(Drawer.Portal, null, /*#__PURE__*/ React.createElement(Drawer.Backdrop, null), /*#__PURE__*/ React.createElement(Drawer.Overlay, {
        "data-t": dataT
    }, /*#__PURE__*/ React.createElement(Drawer.Header, {
        Title: Title
    }), !isRightDirection && /*#__PURE__*/ React.createElement(Drawer.Divider, null), /*#__PURE__*/ React.createElement(Drawer.Content, null, isRightDirection && /*#__PURE__*/ React.createElement(Drawer.Title, null, title), children))));
};

export { PrescriptionFormLabelDetails, PrescriptionFormLabelDetailsDrawer };
//# sourceMappingURL=PrescriptionFormLabelDetails.js.map
